import React from 'react';

import { useFormContext } from 'react-hook-form';

import { z } from 'zod';

import { FormField } from 'components/ui';

import { templateStudioSchema } from '../../../validation-schema';
import { ThemesFormItem } from '../Components/ThemesFormItem';

export const TemplateStudioPromotionForm: React.FC = () => {
  const { control } = useFormContext<z.infer<typeof templateStudioSchema>>();

  return (
    <>
      <FormField
        control={control}
        name="promotion.themes"
        render={({ field }) => (
          <ThemesFormItem onChange={field.onChange} value={field.value || []} />
        )}
      />
    </>
  );
};
